module.exports = __webpack_public_path__ + "static/media/chip_100.56e08ff9.png";